<template>
  <div class="flex-col">
    <div class="flex-row mar-top-10">
      <div class="check-box">
        <icon type="button" @click="toggleAllTime">{{
          isAllTimesSelected ? `check_box` : `check_box_outline_blank`
        }}</icon>
        <span>All day</span>
      </div>

      <div class="check-box">
        <icon type="button" @click="toggleDayTime">{{
          isDayTimesSelected ? `check_box` : `check_box_outline_blank`
        }}</icon>
        <span>Day Time</span>
      </div>

      <div class="check-box">
        <icon type="button" @click="toggleNightTime">{{
          isNightTimesSelected ? `check_box` : `check_box_outline_blank`
        }}</icon>
        <span>Night Time</span>
      </div>
    </div>
    <div class="chits-wrapper">
      <span
        v-for="(time, index) in times"
        :key="index"
        :class="['chit', { active: time.isSelected }]"
        @click="toggleTime(index)"
        >{{ time.name }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      isAllTimesSelected: true,
      isDayTimesSelected: true,
      isNightTimesSelected: true,
      times: [
        {
          id: "6-8",
          name: "6 AM - 8 AM",
          isSelected: true,
        },
        {
          id: "8-10",
          name: "8 AM - 10 AM",
          isSelected: true,
        },
        {
          id: "10-12",
          name: "10 AM - 12 PM",
          isSelected: true,
        },
        {
          id: "12-14",
          name: "12 PM - 2 PM",
          isSelected: true,
        },
        {
          id: "14-16",
          name: "2 PM - 4PM",
          isSelected: true,
        },
        {
          id: "16-18",
          name: "4 PM - 6 PM",
          isSelected: true,
        },
        {
          id: "18-20",
          name: "6 PM - 8 PM",
          isSelected: true,
        },
        {
          id: "20-22",
          name: "8 PM - 10 PM",
          isSelected: true,
        },
        {
          id: "22-0",
          name: "10 PM - 12 AM",
          isSelected: true,
        },
        {
          id: "0-6",
          name: "12 AM - 6 AM",
          isSelected: true,
        },
      ],
    };
  },
  computed: {},
  watch: {
    times: {
      deep: true,
      handler(times) {
        // check for all days
        if (times.filter((item) => item.isSelected).length === 10) {
          this.isAllTimesSelected = true;
        } else {
          this.isAllTimesSelected = false;
        }
        // check for weekdays
        if (times.slice(0, 6).filter((item) => item.isSelected).length === 6) {
          this.isDayTimesSelected = true;
        } else {
          this.isDayTimesSelected = false;
        }
        // check for weekends
        if (times.slice(6, 10).filter((item) => item.isSelected).length === 4) {
          this.isNightTimesSelected = true;
        } else {
          this.isNightTimesSelected = false;
        }

        if (!this.isAllTimesSelected) {
          this.$emit(
            "input",
            this.times.filter((item) => item.isSelected).map((item) => item.id)
          );
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
  methods: {
    toggleTime(toggleIndex) {
      this.times.forEach((time, index) => {
        if (index === toggleIndex) {
          time.isSelected = !time.isSelected;
        }
      });
    },
    toggleAllTime() {
      this.isAllTimesSelected = !this.isAllTimesSelected;
      this.days = this.times.map((item) => {
        item.isSelected = this.isAllTimesSelected;
        return item;
      });
    },
    // toggle all the weekdays
    toggleDayTime() {
      this.isDayTimesSelected = !this.isDayTimesSelected;
      this.times.splice(
        0,
        6,
        ...this.times.slice(0, 6).map((time) => {
          time.isSelected = this.isDayTimesSelected;
          return time;
        })
      );
    },
    // toggle all the weekends
    toggleNightTime() {
      this.isNightTimesSelected = !this.isNightTimesSelected;
      this.times.splice(
        6,
        10,
        ...this.times.slice(6, 10).map((time) => {
          time.isSelected = this.isNightTimesSelected;
          return time;
        })
      );
    },
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.times = this.times.map((item) => {
        item.isSelected = this.value.includes(item.id);
        return item;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.check-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
}

.chits-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;

  .chit {
    padding: 5px 15px;
    background: var(--border-color);
    color: var(--font-color);
    border-radius: 3px;
    margin: 5px;
    font-size: 0.9em;
    transition: 0.3s all ease-in-out;

    &.active {
      background: var(--color-primary);
      color: var(--color-secondary);
    }

    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
}
</style>
